export const PAYMENT_ERROR_CODE = {
  cart_error: "card_error",
  validation_error: "validation_error",
};

export const PriceRange = {
  min: 0,
  max: 2000,
};

export const StatusCodeCheckout = {
  success: "succeeded",
};

export const countLimitProductShow = 5;

export const limitProductInPage = 12;

export const addressShop =
  "35 Phố Mạc Thái Tổ, Yen Hoa, Cầu Giấy, Hanoi, Vietnam";

export const emailAddress = "linh.nguyen6@gmail.com";

export const freeShip = "Free Shipping for all Order big than $1000";

export const optionGoogleMap = {
  componentRestrictions: { country: "vn" },
  fields: ["address_components", "geometry"],
  types: ["address"],
};

export const menuItems = [
  {
    page: "HOME",
    link: "/",
  },
  {
    page: "BLOG",
    link: "",
  },
  {
    page: "CONTACT",
    link: "/contact",
  },
];
